// extracted by mini-css-extract-plugin
export default {"RootClass":"BannerFloating_RootClass__lqUg3"};